export default "__VITE_ASSET__BqFqCQEz__"